var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableInput',_vm._g(_vm._b({staticClass:"vigie-rules",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var remove = ref.remove;
return [_vm._t("default",null,{"remove":remove})]}}],null,true)},'TableInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }